import { createFileRoute } from '@tanstack/react-router';
import { LanguageStepForm } from './-components/project-new-steps/language-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/projects/new/')({
	component: LanguageStepForm,
});
